/**
 * Generates a Google Calendar "Add Event" URL
 * @param {Object} event - Event details
 * @param {string} event.title - Event title
 * @param {string} event.description - Event description
 * @param {string} event.location - Event location
 * @param {Date} event.startDate - Start date/time
 * @param {Date} event.endDate - End date/time
 * @param {boolean} event.allDay - Whether this is an all-day event
 * @returns {string} Google Calendar URL
 */
export const generateGoogleCalendarUrl = ({ title, description, location, startDate, endDate, allDay = false }) => {
  const formatDate = (date, isAllDay) => {
    if (isAllDay) {
      // For all-day events, use YYYYMMDD format only (no time component)
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}${month}${day}`;
    }
    // For timed events, use full ISO format
    return date.toISOString().replace(/-|:|\.\d+/g, '');
  };

  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: title,
    details: description,
    location: location,
    dates: `${formatDate(startDate, allDay)}/${formatDate(endDate, allDay)}`,
  });

  return `https://calendar.google.com/calendar/render?${params.toString()}`;
};

/**
 * Wedding event details for June 5-7, 2025 (3 full days)
 */
export const getWeddingCalendarUrl = (guestName) => {
  // Wedding dates: June 5-7, 2025 (Full 3 days)
  // All-day event spanning the entire celebration
  const startDate = new Date('2025-06-05'); // June 5
  const endDate = new Date('2025-06-08'); // June 8 (end date is exclusive for all-day events, so this includes June 5, 6, 7)

  return generateGoogleCalendarUrl({
    title: 'Petar & Nadya Wedding',
    description: `You're invited to celebrate the wedding of Petar and Nadya!\n\nWe can't wait to see you there!\n\nGuest: ${guestName}`,
    location: 'Wedding Venue', // Update with actual venue address if needed
    startDate,
    endDate,
    allDay: true, // This makes it an all-day event for the full 3 days
  });
};

